module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"header":{"name":"项目","current_reward":"当前奖励","max_reward":"最大奖励"},"footer":{"name":"合计"}}}')
  delete Component.options._Ctor
}
